<div
  *ngIf="!previewMode"
  class="uploadfilecontainer"
  [class.disabled]="disabled"
  (click)="!disabled && fileInput.click()"
  appDragDrop
  (onFileDropped)="!disabled && uploadFile($event)">
  <div class="orange-square"></div>
  <span class="upload-title">{{ uploadTitle | translate }}</span>
  <span class="upload-message">{{ uploadMessage | translate }}</span>
  <input hidden type="file" accept="image/*" #fileInput (change)="uploadFile($event.target.files)" />
</div>
<div *ngIf="googlePostMode">
  <div
    class="uploadfilecontainer-posts mt-3"
    *ngIf="googlePostImagesCount < 10"
    (click)="fileInput.click()"
    appDragDrop
    (onFileDropped)="uploadFile($event)">
    <span class="orange-plus">+</span>
    <input hidden type="file" accept="image/*" #fileInput (change)="uploadFile($event.target.files)" />
  </div>
</div>
